module.exports = __webpack_public_path__ + "img/ch13_15_巷子牵手.699e049d.jpg";